export const BEAUTY_MAKEUP_CATEGORY = {
  key: 'beauty',
  ids: [2278, 2279, 2280, 2281, 2282, 2283, 2288],
};
